import React, { useEffect, useState } from "react";
import { debug } from "../../utils";
import { connect } from "react-redux";
import * as modalDataService from './modalDataService';
import * as validationService from "./validationService";

function SshPasswordlessKeyField({ sshPasswordlessKey, anotherSectionActive, centralCredential, error, disabled }) {

    const [disableValue, setDisableValue] = useState(disabled)

    useEffect(() => {
        if (anotherSectionActive) {
            validationService.cleanValidation('sshPasswordlessKey');
            onChange('');
        }
        else if (centralCredential && centralCredential.id > 0) {
            validationService.cleanValidation('sshPasswordlessKey');
            onChange('');
        }
        else {
            validationService.cleanValidation('sshPasswordlessKey');
        }
        return () => validationService.cleanValidation('sshPasswordlessKey');
    }, [sshPasswordlessKey, anotherSectionActive, centralCredential])

    useEffect(() => {
        if(centralCredential && centralCredential.id > 0) {
            setDisableValue(true);
            //modalDataService.changeSshPassword('')
        }
        else {
            setDisableValue(false);
            //modalDataService.changeSshPassword("");
        }
    }, [centralCredential])

    const onChange = (value) => modalDataService.changePasswordlessKey(value);

    return (
        <div className="form-group">
            <div className="oct_form-group oct_passwordless_key oct_passwordless_key-v2">
                <label htmlFor="ssh_passwordless-key">Passwordless Key</label>
                <textarea className={`form-control oct_field ${error && 'border-danger'}`}
                    id="ssh_passwordless-key"
                    value={sshPasswordlessKey}
                    disabled={disableValue}
                    placeholder={"-----BEGIN RSA PRIVATE KEY-----\nPaste your SSH private key here...\n-----END RSA PRIVATE KEY-----"}
                    onChange={event => onChange(event.target.value)} />
            </div>
        </div>
    )
}

function mapStateToProps(state) {
    debug("SshPasswordlessKeyField mapStateToProps", state);
    const addDeviceModal = state.addDeviceModal;
    const validation = state.validation;
    const anotherSectionActive = !!addDeviceModal.sshPassword;
    return {
        sshPasswordlessKey: addDeviceModal.sshPasswordlessKey || '',
        centralCredential: addDeviceModal.centralCredential || null,
        error: validation.sshPasswordlessKey,
        anotherSectionActive
    }
}

export default connect(mapStateToProps)(SshPasswordlessKeyField);
